var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.375,
    cy: 10.375,
    r: 10.375,
    fill: "#5E639B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.846 5.58008H6.67313C6.10955 5.58008 5.64844 6.04119 5.64844 6.60477V13.7776C5.64844 14.3412 6.10955 14.8023 6.67313 14.8023H13.846C14.4095 14.8023 14.8707 14.3412 14.8707 13.7776V6.60477C14.8707 6.04119 14.4095 5.58008 13.846 5.58008ZM8.21017 12.7529C7.92838 12.7529 7.69782 12.5224 7.69782 12.2406V9.67884C7.69782 9.39705 7.92838 9.1665 8.21017 9.1665C8.49196 9.1665 8.72251 9.39705 8.72251 9.67884V12.2406C8.72251 12.5224 8.49196 12.7529 8.21017 12.7529ZM10.2595 12.7529C9.97776 12.7529 9.7472 12.5224 9.7472 12.2406V8.14181C9.7472 7.86002 9.97776 7.62946 10.2595 7.62946C10.5413 7.62946 10.7719 7.86002 10.7719 8.14181V12.2406C10.7719 12.5224 10.5413 12.7529 10.2595 12.7529ZM12.3089 12.7529C12.0271 12.7529 11.7966 12.5224 11.7966 12.2406V11.2159C11.7966 10.9341 12.0271 10.7035 12.3089 10.7035C12.5907 10.7035 12.8213 10.9341 12.8213 11.2159V12.2406C12.8213 12.5224 12.5907 12.7529 12.3089 12.7529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollIconBlue);
export default __webpack_public_path__ + "static/media/PollIconBlue.5d840ce01db2dcf90d9d08715a741dc0.svg";
export { ForwardRef as ReactComponent };